import { z } from 'zod'

export const REVIEW_HISTORY_OUTCOME_KINDS = [
  'approved',
  'rejected',
  'approved_with_amendments',
  'rejected_then_approved',
  'changes_requested',
  'skipped',
  'under_review',
  'not_started',
  'cancelled',
] as const
export const ReviewHistoryOutcomeKindSchema = z.enum(REVIEW_HISTORY_OUTCOME_KINDS)

export const ReviewHistoryCitationAgentInputSchema = z.object({
  type: z.literal('review_history'),
  requestStepId: z.string().describe('The stable requestStepId shown beside the earlier review or approval step being cited.'),
})

const ReviewHistoryAmendmentSchema = z.object({
  message: z.string().nullable(),
  questionTitle: z.string().nullable(),
  requestedAt: z.string(),
  resolvedAt: z.string().nullable(),
})

/** A decision-time snapshot of the earlier gate, so later timeline changes cannot rewrite the cited evidence. */
export const ReviewHistoryCitationResolvedSchema = z.object({
  sourceType: z.literal('review_history'),
  sourceLabel: z.string().nullable(),
  requestStepId: z.string(),
  requestId: z.string(),
  outcomeKind: ReviewHistoryOutcomeKindSchema,
  reviewedAt: z.string().nullable(),
  rejectionMessage: z.string().nullable(),
  amendments: z.array(ReviewHistoryAmendmentSchema),
})
export type ReviewHistoryCitationResolved = z.infer<typeof ReviewHistoryCitationResolvedSchema>
